import {
	Checkbox,
	Divider,
	FormControlLabel,
	Typography,
} from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import { useTranslation } from 'react-i18next'
import type { TooltipRenderProps } from 'react-joyride'
import LanguageDropdownButton from 'src/components/sections/Navbar/LanguageDropdownButton'

const useTooltipStyles = makeStyles((theme) => ({
	tooltipBody: {
		backgroundColor: '#fff',
		minWidth: '290px',
		maxWidth: '420px',
		position: 'relative',
		borderRadius: '15px',
		padding: '1rem',
		zIndex: 10001,
		pointerEvents: 'auto',
	},
	tooltipContent: {
		color: '#000',
		padding: '0 20px 10px 20px',
		fontSize: '1rem',
	},
	tooltipTitle: {
		color: '#f04',
		padding: '20px',
		margin: '0',
	},
	tooltipFooter: {
		display: 'flex',
		justifyContent: 'flex-end',
		padding: '5px',

		' * + *': {
			marginLeft: '0.5rem',
		},
	},
	// Native button styles to match MUI Button appearance
	nativeButton: {
		marginRight: '0.5rem',
		padding: '4px 10px',
		fontSize: '0.8125rem',
		fontWeight: 500,
		fontFamily: theme.typography.fontFamily,
		lineHeight: 1.75,
		borderRadius: 4,
		border: 'none',
		cursor: 'pointer',
		textTransform: 'uppercase',
		letterSpacing: '0.02857em',
		'&:disabled': {
			opacity: 0.5,
			cursor: 'not-allowed',
		},
	},
	primaryButton: {
		backgroundColor: theme.palette.primary.main,
		color: '#fff',
		'&:hover': {
			backgroundColor: theme.palette.primary.dark,
		},
	},
	secondaryButton: {
		backgroundColor: theme.palette.secondary.main,
		color: '#000',
		'&:hover': {
			backgroundColor: theme.palette.secondary.dark,
		},
	},
}))

const WalkthroughTooltip = ({
	props,
	dontShowTour,
	handleChange,
	disableNextStepsArray,
}: {
	props: TooltipRenderProps
	dontShowTour: boolean
	handleChange: any
	disableNextStepsArray: number[]
}) => {
	const {
		index,
		isLastStep,
		step,
		backProps,
		primaryProps,
		skipProps,
		tooltipProps,
	} = props
	const { t: tSettings } = useTranslation('settings')
	const classes = useTooltipStyles()
	return (
		<div className={classes.tooltipBody} {...tooltipProps}>
			{/* {step.title && <p className={classes.tooltipTitle}>{step.title}</p>} */}
			{step.content && (
				<div className={classes.tooltipContent}>{step.content}</div>
			)}
			<div
				style={{
					display: 'flex',
					justifyContent: 'space-between',
				}}
			>
				<FormControlLabel
					// control={<Checkbox checked={false} name='dontShowTour' size='small' />}
					control={
						<Checkbox
							checked={dontShowTour}
							onChange={handleChange}
							name="dontShowTour"
						/>
					}
					label={
						<Typography variant="subtitle2">
							{tSettings('walkthrough.dontShow')}
						</Typography>
					}
					style={{
						paddingLeft: '20px',
					}}
				/>

				{/* <LanguageDropdownButton noMargin={true} /> */}
			</div>
			<Divider style={{ marginBottom: '0.5rem' }} />
			<div
				style={{
					display: 'flex',
					justifyContent: 'space-between',
					alignItems: 'center',
				}}
			>
				<div>
					{index === 0 && <LanguageDropdownButton noMargin={true} />}
				</div>
				<div className={classes.tooltipFooter}>
					{!isLastStep && (
						<button
							type="button"
							className={`${classes.nativeButton} ${classes.secondaryButton}`}
							{...skipProps}
						>
							{tSettings('walkthrough.skip')}
						</button>
					)}
					{index > 0 && (
						<button
							type="button"
							className={`${classes.nativeButton} ${classes.primaryButton}`}
							{...backProps}
						>
							{tSettings('walkthrough.back')}
						</button>
					)}
					<button
						type="button"
						className={`${classes.nativeButton} ${classes.primaryButton}`}
						{...primaryProps}
						disabled={disableNextStepsArray?.includes(index)}
					>
						{isLastStep
							? tSettings('walkthrough.finish')
							: tSettings('walkthrough.next')}
					</button>
				</div>
			</div>
		</div>
	)
}

export default WalkthroughTooltip
